module.exports = __webpack_public_path__ + "static/media/LogoCareerSuccessAustralia.82649cc4.jpg";